import { render, staticRenderFns } from "./serviceAchievementList.vue?vue&type=template&id=15dad5d0&scoped=true&"
import script from "./serviceAchievementList.vue?vue&type=script&lang=js&"
export * from "./serviceAchievementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dad5d0",
  null
  
)

export default component.exports